import React from 'react';
import bkdbi from '../../assets/bkdbi.jpg'
import './header.css';

const Header = () => {
  return (
    <section className="gpt3__header section__padding" id="home">
      <div className="gpt3__header-content">
        <h1 className="gradient__text">Mission Statement</h1>
        <p className="gpt3__header-lead">Our mission is to bring forward new and aspiring musicians and singers in North America.</p>
        <blockquote className="gpt3__header-quote">"Through Bollywood Ki Dhun, I want to encourage singers and musicians to pursue their passion and perform on a real stage."<span>Rajan Sharma, Founder</span></blockquote>
        <p>We create a platform for South Asian talent to perform, connect, and grow.</p>
    </div>

      <div className="gpt3__header-image">
        <img src={bkdbi} alt="Bollywood Ki Dhun mission and community" />
      </div>

    </section>
  )
};

export default Header
